import theme from "@/constants/theme";
import React, { PropsWithChildren } from "react";

interface DialogProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  children: React.ReactNode;
  style?: React.CSSProperties;
  disabledBackdropClick?: boolean;
}

const Dialog: React.FC<PropsWithChildren<DialogProps>> = ({
  open,
  setOpen,
  children,
  style = {},
  disabledBackdropClick = false,
}) => {
  if (!open) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (disabledBackdropClick) return;
    setOpen(false);
  };

  return (
    <div style={styles.backdropStyle} onClick={handleBackdropClick}>
      <div
        style={{ ...styles.dialogStyle, ...style, position: "relative" }}
        onClick={(e) => e.stopPropagation()}
      >
        <button style={styles.closeButtonStyle} onClick={() => setOpen(false)}>
          ✕
        </button>
        {children}
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  backdropStyle: {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    width: "100vw",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: "16px",
  },
  dialogStyle: {
    backgroundColor: theme.colors.background.primary,
    borderRadius: "10px",
    padding: "20px",
    minWidth: "300px",
    maxWidth: "90vw",
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.3)",
    zIndex: 1001,
    transition: "all 0.3s ease-in-out",
    color: theme.colors.text.body,
    maxHeight: "100%",
    overflow: "auto",
  },
  closeButtonStyle: {
    position: "absolute",
    top: "14px",
    right: "14px",
    cursor: "pointer",
    background: "transparent",
    border: "none",
    fontSize: "1.2rem",
    color: theme.colors.text.default,
  },
};

export default Dialog;
